<template>
  <div class="app-collection-link" v-if="!inApp">
    <a :href="campaignUrl" target="_blank" rel="noopener noreferrer" @click="$sendEvent('Shop The Collection')">
      <svg x="0px" y="0px" viewBox="0 0 10 15">
        <polygon points="2,0 0,2.1 5.8,7.5 0,12.9 2,15 8.9,8.5 10,7.5 8.9,6.5 "/>
      </svg>
      <span v-html="$translate('layout').shopButton.content" />
    </a>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import anime from '@/assets/libs/anime';
import { inApp } from '@/scripts/utils';

export default {
  name: 'AppCollectionLink',

  props: {
    campaignUrl: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      inApp: inApp(),
    };
  },

  computed: {
    ...mapState({
      game: 'currentGame',
    }),
  },

  mounted() {
    if (inApp()) return;

    anime.set(this.$el, { translateY: 20, opacity: 0 });

    this.handlerAnimations = (bool, delay = 0) => {
      if (bool) this.enter(delay);
      else this.leave(delay);
    };
    this.$nextTick(() => this.$eventHub.$on('windowResize', this.hide));
    this.$eventHub.$on('showCollectionLink', this.handlerAnimations);
  },

  methods: {
    enter(delay) {
      return anime({
        targets: this.$el,
        translateY: window.innerWidth < 768 ? [0, 0] : [20, 0],
        opacity: window.innerWidth < 768 ? [1, 1] : [0, 1],
        scale: window.innerWidth < 768 ? [0, 1] : [1, 1],
        duration: 1000,
        delay,
        easing: 'cubicBezier(.5,0,0,1)',
      });
    },

    leave(delay) {
      return anime({
        targets: this.$el,
        translateY: window.innerWidth < 768 ? [0, 0] : [0, -20],
        opacity: window.innerWidth < 768 ? [1, 1] : [1, 0],
        scale: window.innerWidth < 768 ? [1, 0] : [1, 1],
        duration: 1000,
        delay,
        easing: 'cubicBezier(.5,0,0,1)',
      });
    },

    hide() {
      if (this.game.questionsIndex < 0) return;
      if (window.innerWidth < 768) anime.set(this.$el, { scale: !this.game.gameEnded ? 0 : 1 });
      else anime.set(this.$el, { opacity: 1, translateY: 0, scale: 1 });
    },
  },

  beforeDestroy() {
    this.$eventHub.$off('showCollectionLink', this.handlerAnimations);
  },
};
</script>

<style lang="scss" scoped>
.app-collection-link {
  display: flex;
  align-items: center;
  justify-content: center;

  @include mq(ipadP) {
    position: absolute;
    bottom: calc(var(--unit-vh) * 0.20);
    right: 0;
    width: calc(var(--unit-vw) * 6);

    a {
      position: relative;

      display: flex;
      align-items: center;
      justify-content: center;
    }

    span {
      color: #F1E5C0;
      font-size: rem(18px);
      font-size: calc(18px * var(--rw));
      line-height: rem(55px);
      line-height: calc(55px * var(--rw));
      @include mq(ipadL) {
        &::v-deep {
          br {
            display: none;
          }
        }
      }
    }

    svg {
      height: 15px;
      margin-right: 15px;
      fill: #F1E5C0;
      transition: transform 0.5s cubic-bezier(.5,0,0,1);
    }

    @include mq($and: $is-not-touch-device) {
      a:hover svg {
        transform: translateX(5px);
      }
    }
  }

  @include mq($until: ipadP) {
    position: absolute;
    top: calc(var(--unit-vh) * 2);
    right: 10px;
    width: calc(150px * var(--rw));
    height: calc(150px * var(--rw));

    background-image: url('/img/svg/happy-background.svg');
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;

    z-index: 5;

    svg {
      display: none;
    }

    span {
      display: block;
      color: $color-white;
      font-size: 10px;
      line-height: 1.2;
      transform: rotate(-15deg);
    }
  }
}
</style>
